import { render, staticRenderFns } from "./SearchHighlight.vue?vue&type=template&id=10b3f632&"
import script from "./SearchHighlight.vue?vue&type=script&lang=js&"
export * from "./SearchHighlight.vue?vue&type=script&lang=js&"
import style0 from "./SearchHighlight.vue?vue&type=style&index=0&id=10b3f632&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports